'use client';

import { SectionHeader, StatusBadge, type StatusType } from '../shared';

interface ListItem {
  semantic_id?: string;
  name?: string;
  status?: string;
  state?: string;
}

interface ListSectionProps {
  items: ListItem[] | null | undefined;
  label?: string | null;
  maxItems?: number | null;
  entityType?: string;
}

export function ListSection({ items, label, maxItems, entityType }: ListSectionProps) {
  if (!items || items.length === 0) {
    return null;
  }

  const displayItems = maxItems ? items.slice(0, maxItems) : items;
  const hasMore = maxItems && items.length > maxItems;

  // Determine status badge type based on label or entity type
  const badgeType: StatusType = label?.toLowerCase().includes('rfq')
    ? 'rfq'
    : label?.toLowerCase().includes('order')
    ? 'po'
    : 'rfq';

  return (
    <div>
      <SectionHeader title={label || 'ITEMS'} count={items.length} />
      <div className="space-y-1">
        {displayItems.map((item) => (
          <div
            key={item.semantic_id}
            className="flex items-center justify-between p-2 rounded-lg bg-card border border-border"
          >
            <span className="text-xs truncate flex-1">
              {item.name || item.semantic_id}
            </span>
            {(item.status || item.state) && (
              <StatusBadge
                status={item.status || item.state}
                type={badgeType}
                className="ml-2 shrink-0"
              />
            )}
          </div>
        ))}
        {hasMore && (
          <div className="text-xs text-muted-foreground text-center py-1">
            +{items.length - (maxItems || 0)} more
          </div>
        )}
      </div>
    </div>
  );
}
